import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../../../button";
import { PlanManagement } from "../../details/plan/plan-management.component";
export class AddPlanModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      selected:[],
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show}=this.state;
    return(
      <>

    
      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="file-plus" iconSize="17px" customClassName="header-filter-button" labelName={this.props.labelName}/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch finance-modal-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>Plan Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <div className="finance-detail-table">
             <PlanManagement />  
           </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>Save</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
